import './SignUpNewMemberPage.css';

import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Banner from '../../b2b-common/Banner';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import useGettingUserFromInviteToken from '../hooks/useGettingUserFromInviteToken';
import EditText from '../../b2b-common/EditText';
import { Logo } from '../../LoginPage';
import CustomButton from '../../b2b-common/CustomButton';
import { useState } from 'react';
import NotificationSnackbar from '../../b2b-common/NotificationSnackbar';
import { newUserInvited } from '../../../services/b2b-users-apiService';

const SignUpNewMemberPage = () => {
    const { t } = useB2BTranslation('b2b-users');

    const location = useLocation();
    const token = new URLSearchParams(location.search).get('inviteToken');

    const { user, setUser, isLoading } = useGettingUserFromInviteToken(token);
    const [openNotification, setOpenNotification] = useState(false);
    const [notification, setNotification] = useState({
        message: '',
        type: 'info',
        millisecs: 3000,
    });

    if (isLoading) {
        return <div>{t('Loading...')}</div>;
    }

    const validateUserData = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!user.email) {
            return t('Email is required');
        }
        if (!emailRegex.test(user.email)) {
            return t('Invalid email format');
        }
        if (!user.firstName) {
            return t('First Name is required');
        }
        if (!user.lastName) {
            return t('Last Name is required');
        }
        if (!user.password) {
            return t('Password is required');
        }
        if (user.password !== user.rep_password) {
            return t('Passwords do not match');
        }
        return null;
    }

    const createUserAfterInvite = async () => {
        try {
            await newUserInvited(token, user.userOrganizations[0].organization.organizationUUID, user);
            setNotification({
                message: t('User created successfully'),
                type: 'success',
                millisecs: 3000,
            });
            setOpenNotification(true);
        } catch (error) {
            console.error('Error creating user:', error);
            setNotification({
                message: t('Error creating user'),
                type: 'error',
                millisecs: 5000,
            });
            setOpenNotification(true);
        }
    }

    const handleSignUp = async () => {
        console.log('SignUpNewMemberPage handleSignUp user:', user);
        const validationError = validateUserData();
        if (validationError) {
            setNotification({
                message: validationError,
                type: 'warning',
                millisecs: 3000,
            });
            setOpenNotification(true);
            return;
        }
        createUserAfterInvite();
    }
    
    return (
        <Box p={5}>
            <Banner sectionTittle={`${t('Adding new member to:')}`} message={user.userOrganizations[0].organization.organizationName} underline={false} headingLevel='h1' />
            <Box className={'sign-up-new-member-page'} p={5} width={'70%'} height={'100%'} display={'flex'} flexDirection={'row'} gap={3} boxSizing={'border-box'} alignItems={'flex-start'} justifyContent={'center'} justifySelf={'center'} >
                <Box className={'sign-up-organization-logo'} p={5} display={'flex'} flexDirection={'column'} justifyContent={'flex-start'} alignItems={'flex-start'} width={'30%'} height={'100%'}>
                    <Logo altText="Back2Blu" organizationUuid={user.userOrganizations[0].organization.organizationUUID} />
                </Box>
                <Box className={'sign-up-new-member-details'} p={5} width={'70%'} display={'flex'} flexDirection={'column'} gap={3} boxSizing={'border-box'} alignItems={'center'} justifyContent={'center'}>
                    <Banner message={t('New member details')} underline={false} headingLevel='h2' />
                    <Box className={'sign-up-new-member-details-content'} display={'flex'} flexDirection={'column'} gap={2} width={'100%'} >
                        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} gap={3} width={'100%'}>
                            <EditText object={user} objectField='email' setObjectField={setUser} label={t('Email')} readOnly={true} />
                            <EditText object={user} objectField='locale' setObjectField={setUser} label={t('Language')} required
                                options={[
                                    { value: 'es', label: t('Spanish') },
                                    { value: 'ca', label: t('Catalan') },
                                    { value: 'en', label: t('English') },
                                    { value: 'fr', label: t('French') },
                                ]}
                            />
                        </Box>
                        <EditText object={user} objectField='firstName' setObjectField={setUser} label={t('First Name')} required />
                        <EditText object={user} objectField='lastName' setObjectField={setUser} label={t('Last Name')} required />
                        <EditText object={user} objectField='password' setObjectField={setUser} label={t('Password')} type='password' required />
                        <EditText object={user} objectField='rep_password' setObjectField={setUser} label={t('Repeat Password')} type='password' required />
                        <Box pt={2}>
                            <CustomButton label={t('Sign Up')} onClick={handleSignUp} className={'sign-up-new-member-button'} />
                        </Box>
                    </Box>
                </Box>
            </Box>
            <NotificationSnackbar
                open={openNotification}
                message={notification.message}
                type={notification.type}
                millisecs={notification.millisecs}
                onClose={() => setOpenNotification(false)}
            />
        </Box>
    );
}

export default SignUpNewMemberPage;